import {useParams} from "react-router-dom";
import {useReadProductDetailEx} from "./hooks/useReadProductDetailEx";
import {useEffect, useState} from "react";
import {ProductExDetailSearchParamType, ProductExDetailType} from "./interface";
import {productExDetailInit, productExDetailSearchParamInit} from "./state";
import Section1 from "./features/Section1";
import Section2 from "./features/Section2";
import Section3 from "./features/Section3";
import Section4 from "./features/Section4";
import {useForm, useWatch} from "react-hook-form";
import {useDeleteProductEx} from "./hooks/useDeleteProductEx";
import {useModal} from "../../../../hooks";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export default function ProductExDetail() {
    const {id} = useParams()
    const {handleModal} = useModal();

    // Section4의 적용하기 버튼으로 Section3(상세정보)의 배송방법을 세팅하기 위한 state
    const [appliedNewPShipment, setAppliedNewPShipment] = useState<number>(0)
    const [searchParam, setSearchParam] = useState<ProductExDetailSearchParamType>(productExDetailSearchParamInit)

    const {mutate: mutateDeleteProductEx} = useDeleteProductEx()
    const {data} = useReadProductDetailEx({param: {...searchParam, newErpProductid: id ?? ""}})
    const productResult: ProductExDetailType = data ?? productExDetailInit

    const {register, getValues, setValue, control, handleSubmit, watch} = useForm({
        defaultValues: productResult
    })

    const product = {
        ...productResult,
        ...useWatch<ProductExDetailType>({control}),
    } as ProductExDetailType

    const btnDelete = () => {
        handleModal({
            isOpen: true,
            contents: "삭제하시겠습니까?",
            type: "confirm",
            callback: () => mutateDeleteProductEx({...searchParam, newErpProductid: id ?? ""})
        })
    }

    // data 로딩 후 product 재설정
    useEffect(() => {
        if (data) {
            Object.keys(data).forEach((key) => {
                setValue(key as keyof ProductExDetailType, data[key as keyof ProductExDetailType]);
            });
        }
    }, [data, setValue]);

    return <>
        <div className="content_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">제품 상세보기</h3>
                <div className="filter_toolbar">
                    <AuthorityChecker authorityNames={['productWriteYn']}>
                        <button className="btn btn-outline-dark" onClick={btnDelete}>
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>제품삭제
                        </button>
                    </AuthorityChecker>
                </div>
            </div>

            <Section1 product={product}/>

            <Section2 product={product}/>

            <Section3 product={product}
                      appliedNewPShipment={appliedNewPShipment}/>

            <Section4 setValue={setValue}
                      setAppliedNewPShipment={setAppliedNewPShipment}/>
        </div>
    </>
}